import { NgModule } from '@angular/core';

import { CallStateDirective } from './call-state.directive';

@NgModule({
   declarations: [CallStateDirective],
   exports: [CallStateDirective],
})
export class CallStateModule {}
